<ion-list lines="none">
  @for (item of _items(); track $index) {
    <ion-item>
      <ion-label (click)="item.click()">{{ item.name }}</ion-label>
    </ion-item>
  }
</ion-list>
